import { AptunoException } from '..';
import { AptunoError } from '../models/error.model';

export const ResponseAxiosErrorMapping = (error: AptunoException): AptunoError => {
  const domainError: AptunoError | undefined = error.errors?.[0];

  return (
    domainError || {
      code: error ? 'NETWORK_ERROR' : 'DEFAULT',
      type: 'UNKNOWN',
    }
  );
};
